/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_WorkflowInputs */

const en_logistics_workflow = /** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics Workflow`)
};

const es_logistics_workflow = /** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de Trabajo Logístico`)
};

const fr_logistics_workflow = /** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux logistique`)
};

const de_logistics_workflow = /** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistik-Workflow`)
};

const id_logistics_workflow = /** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alur Kerja Logistik`)
};

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const ja_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const zh_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const ar_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const it_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const ru_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const pt_logistics_workflow = en_logistics_workflow;

/** @type {(inputs: Logistics_WorkflowInputs) => LocalizedString} */
const ko_logistics_workflow = en_logistics_workflow;

/**
* | output |
* | --- |
* | "Logistics Workflow" |
*
* @param {Logistics_WorkflowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const logistics_workflow = /** @type {((inputs?: Logistics_WorkflowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_WorkflowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_workflow(inputs)
	if (locale === "es") return es_logistics_workflow(inputs)
	if (locale === "fr") return fr_logistics_workflow(inputs)
	if (locale === "de") return de_logistics_workflow(inputs)
	if (locale === "ja") return ja_logistics_workflow(inputs)
	if (locale === "zh") return zh_logistics_workflow(inputs)
	if (locale === "ar") return ar_logistics_workflow(inputs)
	if (locale === "id") return id_logistics_workflow(inputs)
	if (locale === "it") return it_logistics_workflow(inputs)
	if (locale === "ru") return ru_logistics_workflow(inputs)
	if (locale === "pt") return pt_logistics_workflow(inputs)
	return ko_logistics_workflow(inputs)
});